import React from 'react';
import { useMediaQuery } from 'react-responsive';
import PressContent from './PressContent';

const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 768 });
  return isDesktop ? children : null;
};

const DesktopResponsive = ({ history }) => (
  <Desktop>
    <PressContent history={history} />
  </Desktop>
);

export default DesktopResponsive;
